import React from 'react'
import Work from '../components/Work'

const WorkPage = () => {
  return (
    <div style={{padding:"5rem 0",backgroundColor:"var(--green)"}}>
      <h3 className='sec-title'> Work</h3>
    <Work/>
      
    </div>
  )
}

export default WorkPage
